"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabletop = _interopRequireWildcard(require("cccisd-tabletop"));
var _pageVisitByVisit = _interopRequireDefault(require("./pageVisitByVisit.graphql"));
var _pageVisitVisualization = _interopRequireDefault(require("./pageVisitVisualization.graphql"));
var _pageVisitViz = _interopRequireDefault(require("./pageVisitViz.js"));
var _logTableRenders = _interopRequireDefault(require("../../../helpers/logTableRenders.js"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// import pageVisitByVisitor from './pageVisitByVisitor.graphql';
// import pageVisitByUrl from './pageVisitByUrl.graphql';

var pageVisitTable = function pageVisitTable() {
  var maxDate = (0, _moment["default"])().format('YYYY-MM-DD');
  var minDate = (0, _moment["default"])().subtract(60, 'days').format('YYYY-MM-DD');
  var variables = {
    minDate: minDate,
    maxDate: maxDate
  };
  var byView = {
    query: _pageVisitByVisit["default"],
    rowKey: 'eventId',
    isAscentOrder: false,
    handle: 'pageVisitByVisit',
    visualize: {
      query: _pageVisitVisualization["default"],
      charts: _pageVisitViz["default"],
      variables: variables
    },
    columns: [{
      name: 'eventAt',
      label: 'Visit Date',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      },
      width: '170px'
    }, {
      name: 'durationSeconds',
      label: 'Time Spent',
      sort: true,
      render: _logTableRenders["default"].durationRender,
      hideInCsv: true
    }, {
      name: 'durationSeconds',
      label: 'Duration (seconds)',
      hideInTable: true
    }, {
      name: 'url',
      label: 'Page',
      sort: true,
      filter: true,
      render: _logTableRenders["default"].linkRender
    }, {
      name: 'pawnId',
      label: 'Visitor ID',
      sort: true,
      filter: true
    }, {
      name: 'pawn.pawn.roleName',
      label: 'Role',
      sort: true,
      filter: true
    }, {
      name: 'pawn.user.username',
      label: 'Username',
      sort: true,
      filter: true
    }]
  };

  // const byVisitor = {
  //     query: pageVisitByVisitor,
  //     rowKey: 'pawn.pawnId',
  //     handle: 'pageVisitByVisitor',
  //     visualize: {
  //         query: pageVisitVizQuery,
  //         charts: pageVisitCharts,
  //         variables,
  //     },
  //     columns: [
  //         {
  //             name: 'pawn.pawnId',
  //             label: 'Visitor ID',
  //             sort: true,
  //             filter: true,
  //         },
  //         {
  //             name: 'pawn.roleName',
  //             label: 'Role',
  //             sort: true,
  //             filter: true,
  //         },
  //         {
  //             name: 'user.username',
  //             label: 'Username',
  //             sort: true,
  //             filter: true,
  //         },
  //         {
  //             name: 'eventSummary.duration',
  //             label: 'Total duration',
  //             sort: true,
  //             render: tableRenders.durationRender,
  //             hideInCsv: true,
  //         },
  //         {
  //             name: 'eventSummary.duration',
  //             label: 'Duration (seconds)',
  //             hideInTable: true,
  //         },
  //         {
  //             name: 'eventCount',
  //             label: 'Page visits',
  //             sort: true,
  //             filter: true,
  //         },
  //         {
  //             name: 'eventSummary.minDate',
  //             label: 'First visit',
  //             width: '170px',
  //             sort: true,
  //             filter: true,
  //             filterSettings: { type: 'date' },
  //         },
  //         {
  //             name: 'eventSummary.maxDate',
  //             label: 'Latest visit',
  //             width: '170px',
  //             sort: true,
  //             filter: true,
  //             filterSettings: { type: 'date' },
  //         },
  //     ],
  // };

  // const byUrl = {
  //     query: pageVisitByUrl,
  //     rowKey: 'value',
  //     handle: 'pageVisitByUrl',
  //     visualize: {
  //         query: pageVisitVizQuery,
  //         charts: pageVisitCharts,
  //         variables,
  //     },
  //     columns: [
  //         {
  //             name: 'value',
  //             label: 'URL',
  //             render: tableRenders.linkRender,
  //             sort: true,
  //             filter: true,
  //         },
  //         {
  //             name: 'valueCount',
  //             label: 'Page visits',
  //             sort: true,
  //             filter: true,
  //         },
  //         {
  //             name: 'duration',
  //             label: 'Total duration',
  //             render: tableRenders.durationRender,
  //             hideInCsv: true,
  //             sort: true,
  //         },
  //         {
  //             name: 'duration',
  //             label: 'Duration (seconds)',
  //             hideInTable: true,
  //         },
  //         {
  //             name: 'minDate',
  //             label: 'First visit',
  //             width: '170px',
  //             filterSettings: { type: 'date' },
  //             sort: true,
  //             filter: true,
  //         },
  //         {
  //             name: 'maxDate',
  //             label: 'Latest visit',
  //             width: '170px',
  //             filterSettings: { type: 'date' },
  //             sort: true,
  //             filter: true,
  //         },
  //     ],
  // };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], {
    handle: "pageVisits",
    saveState: true,
    views: [{
      handle: 'pagesByView',
      title: 'Page Visits - by Visit',
      table: byView,
      buttons: [_cccisdTabletop.visualizeButton]
    }
    // {
    //     handle: 'pagesByVisitor',
    //     title: 'Page Visits - by Visitor',
    //     table: byVisitor,
    // },
    // {
    //     handle: 'pagesByUrl',
    //     title: 'Page Visits - by Url',
    //     table: byUrl,
    // },
    ]
  }));
};
var _default = exports["default"] = {
  name: 'visits',
  title: 'Page Visits',
  content: pageVisitTable()
};